import { ListItem, ListItemIcon, ListItemText, IconButton, Typography } from '@mui/material';
import React from 'react';

import FileIcon from '@/assets/icons/file.svg?react';
import TrashIcon from '@/assets/icons/trash.svg?react';
import { Document } from '@/models/Document';
export interface UploadedFileListItemProps {
  file: Document;
  onDelete: (file: Document) => void;
}

export const UploadedFileListItem: React.FC<UploadedFileListItemProps> = ({ file, onDelete }) => {
  const getFileSizeInMegabytes = (file: Document) => {
    const fileSize = (file.fileSize / (1024 * 1024)).toFixed(2);
    return `${fileSize}MB`;
  };

  return (
    <ListItem
      sx={{
        minHeight: 72,
        backgroundColor: 'background.neutral',
        pr: 14,
        borderRadius: 4,
        mb: 4,
      }}
      secondaryAction={
        <IconButton aria-label="delete" onClick={() => onDelete(file)} sx={{ ml: 2, mr: -2 }}>
          <TrashIcon width={28} height={30} strokeWidth={1} />
        </IconButton>
      }>
      <ListItemIcon sx={{ minWidth: 0, mr: 2.5 }}>
        <FileIcon width={28} height={30} strokeWidth={1} />
      </ListItemIcon>
      <ListItemText
        sx={{ mr: 2 }}
        primary={
          <Typography
            variant="body2"
            noWrap
            title={file.filename}
            sx={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}>
            {file.filename}
          </Typography>
        }
      />
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {getFileSizeInMegabytes(file)}
      </Typography>
    </ListItem>
  );
};

export default UploadedFileListItem;
